var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmallPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15367_15666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15367_15666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.063L8.91988 16.1515C8.77388 16.2964 8.59687 16.3672 8.38887 16.364C8.18071 16.3607 8.00371 16.2866 7.85788 16.1418C7.71304 15.9969 7.64062 15.8197 7.64062 15.61C7.64062 15.4005 7.71304 15.2233 7.85788 15.0783L10.9366 12.0003L7.85788 8.94427C7.71304 8.79827 7.64062 8.61969 7.64062 8.40852C7.64062 8.19719 7.71304 8.01852 7.85788 7.87252C8.00271 7.72769 8.17996 7.65527 8.38962 7.65527C8.59912 7.65527 8.77638 7.72769 8.92138 7.87252L12.0001 10.961L15.0554 7.87252C15.2014 7.72769 15.3784 7.65527 15.5864 7.65527C15.7945 7.65527 15.9715 7.72769 16.1174 7.87252C16.2725 8.02769 16.3501 8.20752 16.3501 8.41202C16.3501 8.61652 16.2725 8.79119 16.1174 8.93602L13.0386 11.9995L16.1271 15.0798C16.272 15.2258 16.3444 15.4028 16.3444 15.6108C16.3444 15.8189 16.272 15.9959 16.1271 16.1418C15.972 16.2969 15.7921 16.3745 15.5876 16.3745C15.3831 16.3745 15.2085 16.2969 15.0636 16.1418L12.0001 13.063Z",
    fill: "#F1F1F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmallPortfolio);
export default __webpack_public_path__ + "static/media/close_small_portfolio.3e3bd06186f518fb4ef495010238fdf1.svg";
export { ForwardRef as ReactComponent };